import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_orders_by_order_idsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { order_ids: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, OrderStatusId?: number, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { ContainerSize?: string, ExpectedDate?: string, ExpectedWarehouseId?: number, StatusId?: number, Wave?: { Id?: number, Status?: { Id?: number, Name?: string } } } }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.order_ids)) {
      missingRequiredInParams.push('\'order_ids\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_get_orders_by_order_ids/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { order_ids: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, OrderStatusId?: number, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { ContainerSize?: string, ExpectedDate?: string, ExpectedWarehouseId?: number, StatusId?: number, Wave?: { Id?: number, Status?: { Id?: number, Name?: string } } } }[] }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.order_ids)) {
      missingRequiredInParams.push('\'order_ids\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_get_orders_by_order_ids/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { order_ids: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, OrderStatusId?: number, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { ContainerSize?: string, ExpectedDate?: string, ExpectedWarehouseId?: number, StatusId?: number, Wave?: { Id?: number, Status?: { Id?: number, Name?: string } } } }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.order_ids)) {
      missingRequiredInParams.push('\'order_ids\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_get_orders_by_order_ids/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      order_ids: number[]    }) {
        if(isNil(inParams.order_ids)) {
          return true; 
        }
      return false;
    }
}
